'use client';

import React, { FC, useCallback, useContext } from 'react';
import { usePathname, useRouter } from 'next/navigation';
import { PlusIcon } from 'components/icons/v2';
import { Button } from 'components/ui/button';
import { useAuth } from 'contexts/auth';
import { RoleEnum } from 'generated/types';
import LinkedinContext from '../../../_context/LinkedinContext';
import { DealsContext } from '../../_context/DealContext';

export const AddDealLink: FC = () => {
  const pathname = usePathname();
  const router = useRouter();

  const { currentUser } = useAuth();
  const { openDealModal } = useContext(DealsContext);
  const { setLinkedinModalState } = useContext(LinkedinContext);

  const handleOpenCreateNeedHelp = useCallback(() => {
    if (currentUser?.communityMember?.role === RoleEnum.Member && !currentUser?.profileStatus) {
      setLinkedinModalState(() => 'WELCOME');
      return;
    }

    openDealModal((prevState => !prevState)(), undefined);
  }, [currentUser?.communityMember?.role, currentUser?.id, currentUser?.profileStatus, openDealModal, pathname, router, setLinkedinModalState]);

  return (
    <Button
      variant='nakedGrayLink'
      size='medium'
      className=''
      onClick={handleOpenCreateNeedHelp}
    >
      <PlusIcon />
      Add a deal
    </Button>
  );
};
